export default {
  headers: {
    datetime: 'Fecha y Hora',
    company: 'Empresa',
    previous: 'Estado previo',
    current: 'Estado actual',
    consultant: 'Gestora',
    comments: 'Observaciones'
  },
  title: 'Histórico de cambios de factura'
}
